var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],tag:"component"},[_c('ErrorListener',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }